<script>
    import { fade } from 'svelte/transition';
    import {API_URL} from '../constants/api'
    import FVHero from '../components/FVHero.svelte'
    import Centering from '../layouts/Centering.svelte'
    import FillButton from '../components/FillButton.svelte'
    import Heading from '../components/Heading.svelte'
    import Article from '../widgets/Article.svelte'
    export let params = {}
    const src = {
        pc:"img/news-fv.png",
        mb:"img/news-fv_mb.png"
    }
    async function getNews() {
		const res = await fetch(`${API_URL}/data.json`);
		const data = await res.json();

		if (res.ok) {
            for(let i of data.news){
                if(i.id === parseInt(params.id)) return i
            }
		} else {
			throw new Error(data);
		}
    }
const promise = getNews()
</script>
<svelte:head>
	<title>ニュース | 株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
    <FVHero images={src} />
    <div class="mt"></div>
    <Centering>
        <Heading
            text={{
                main:"NEWS",
                sub:"ニュース"
            }}
        />
    </Centering>
    {#await promise then data}
    <Article        
        title={data.title}
        date={data.date}
        content={data.content} 
    />          
    {/await}
    <Centering>
    <div class="btn-layout">
        <FillButton 
        href="/news"
        style={{
            width:325,
            height:60,
            borderWidth:2,
            color:"#FF9B11",
            base:"#F5F5F5"
        }}
        text="ニュース一覧を見る"
    />
    </div>
    </Centering>
    <div class="mb"></div>
</div>
<style>
    .mt{
        margin-top: 75px;
    }
    .btn-layout{
        margin-top: 90px;
    }
    .news-list{
        border-top: 1px solid #000;
        margin-top: 50px;
        margin-bottom: 125px;
    }
    .mb{
        margin-bottom: 125px;
    }
</style>